export const defaultLocale = "en" as const;
export const locales = [defaultLocale, "ru"] as const;
export type Locale = (typeof locales)[number];
